export * from './ProductAvailableRecommendationSliderArea'
